import { useEffect, useState, useMemo, useRef } from "react";
import { parse, format } from 'date-fns';
import CalendarEventDay from "./CalendarEventDay";
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { getCultureInfo, callApi, isTodayOrFutureDate, ErrorAlert } from '../crud/utils';
import { t } from "./../i18n";

function DayView(props) {
    const [serverUrl] = useState(props.userApp.serverUrl);
    const [language] = useState(getCultureInfo(props.userApp.sessionToken?.Language));
    const [User3pl] = useState(props.userApp.sessionToken?.User3pl);
    const [SupplierId] = useState(props.userApp.sessionToken?.SupplierId);
    const [role] = useState(props.userApp.sessionToken?.Role);
    const [contextMenu, setContextMenu] = useState(null);
    const contextMenuDataRef = useRef(null);
    const [ymsBooking, setYmsBooking] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
    const [capacityPerTimeSlot, setCapacityPerTimeSlot] = useState([]);
    const [isEventContextMenuOpen, setIsEventContextMenuOpen] = useState(false);
    const [hoveredBookingId, setHoveredBookingId] = useState(null);
    const [sumCategoriesData, setSumCategoriesData] = useState([]);


    useEffect(() => {
        async function fetchCapacity() {
            if (!props.warehouseid || !props.currentDate) return;

            const fromDate = format(new Date(props.currentDate), "yyyy-MM-dd");
            const url = `${serverUrl}/api/Capacity?fromDateTime=${fromDate}&warehouseId=${props.warehouseid}`;

            try {
                const result = await callApi("GET", url, props.userToken, null, null, null);
                setCapacityPerTimeSlot(result)
            } catch (error) {
                console.error("❌ Capacity API call error:", error.message);
            }
        }

        fetchCapacity();
    }, [props.warehouseid, props.data, props.currentDate, props.userToken, serverUrl]);

    useEffect(() => {
        async function fetchSumCategories() {
            if (!props.warehouseid || !props.currentDate) return;

            const payload = {
                WarehouseId: Number(props.warehouseid),
                InDate: new Date(props.currentDate)
            };

            try {
                const result = await callApi("POST", `${serverUrl}/api/sumcategories`, props.userToken, payload);
                setSumCategoriesData(result || []);
            } catch (error) {
                console.error("❌ SumCategories API call error:", error.message);
                setSumCategoriesData([]);
            }
        }

        fetchSumCategories();
    }, [props.warehouseid, props.currentDate, props.userToken, serverUrl, props.actionRefresh]);

    useEffect(() => {
        async function getWarehouse() {
            if (!props.warehouseid) return;
            if (!props.data) return;
            if (!props.data["Yms_Warehouses"]) return;
            let dstart = 0;
            let dend = 24;
            const wrh = await props.data["Yms_Warehouses"].find(r => Number(r.WarehouseId) === Number(props.warehouseid));
            if (wrh) {
                if (wrh.StartTime) dstart = parse(wrh.StartTime, 'HH:mm', new Date()).getHours();
                if (wrh.EndTime) dend = parse(wrh.EndTime, 'HH:mm', new Date()).getHours() + 1;
            }
            let timSlots = [];
            let min = 0;

            let timeSlotDay = new Date(props.currentDate);
            timeSlotDay.setHours(0, 0, 0, 0);
            for (let hour = dstart; hour < dend; hour++) {
                //  for (min = 0 ; min < 60 ; min +=30){
                let time = new Date(timeSlotDay);
                time.setHours(hour, min, 0, 0);
                timSlots.push(time);
                //  }
            }
            setTimeSlots(timSlots);
        } getWarehouse();

    }, [props.warehouseid, props.data, props.currentDate])

    useEffect(() => {
        async function getBooking() {
            let data = props.data["Yms_Booking"] ? props.data["Yms_Booking"] : [];
            setYmsBooking(data);
            // console.log("DayView bookings set:", data);
        }
        getBooking();
    }, [props.data]);

    //Older Version 
    // const ymsBookingsPerDay = ymsBooking.filter((recYmsbook) => {
    //     const currentDate = new Date(props.currentDate);
    //     const inDate = new Date(recYmsbook.FromDate);
    //     const isSameWarehouse = Number(recYmsbook.WarehouseId || 0) === Number(props.warehouseid || 0);
    //     const isInDay = (inDate.getFullYear() === currentDate.getFullYear() &&
    //         inDate.getMonth() === currentDate.getMonth() &&
    //         inDate.getDate() === currentDate.getDate())
    //     return isInDay && isSameWarehouse;
    // });

    const ymsBookingsPerDay = ymsBooking.filter(recYmsbook => {
        const currentDate = new Date(props.currentDate);
        const inDate = new Date(recYmsbook.FromDate);
        const isSameWarehouse = Number(recYmsbook.WarehouseId || 0) === Number(props.warehouseid || 0);
        return (
            inDate.getFullYear() === currentDate.getFullYear() &&
            inDate.getMonth() === currentDate.getMonth() &&
            inDate.getDate() === currentDate.getDate() &&
            isSameWarehouse
        );
    });

    function gatDisabledView(recYmsbook) {
        //Admin.Administrator,Supplier.Προμηθευτής,3pls.3pls,Planner.Planner,DoorUser.Χρήστης πύλης
        if (role === "Supplier") {
            if (SupplierId) {
                const BookingSuppliersID = recYmsbook?.BookingSuppliersID?.split(",").map(Number);
                const exists = BookingSuppliersID?.includes(Number(SupplierId));
                if (!exists) return true;
            }
        }
        else if (role === "3pls") {
            if (User3pl) {
                const bookingYms3plId = Number(recYmsbook?.Yms3plId);
                const userYms3plId = Number(User3pl);
                if (bookingYms3plId !== userYms3plId) return true;

                if (props.data["Yms_3plSuppliers"]) {
                    const BookingSuppliersID = recYmsbook?.BookingSuppliersID?.split(",").map(Number) || [];
                    const user3plSupplierIds = props.data["Yms_3plSuppliers"]
                        .filter(s => Number(s.Yms3plId) === userYms3plId)
                        .map(s => Number(s.SupplierId));

                    const hasAccessToSupplier = BookingSuppliersID.some(supplierId =>
                        user3plSupplierIds.includes(supplierId)
                    );

                    if (!hasAccessToSupplier) return true;
                }
            }
        }
        return false; // Default to false, meaning no actions are disabled
    }

    const renderedEventIds = new Set();
    const columnMap = {};
    const slotStackMap = {};

    const handleClose = () => {
        setContextMenu(null);
    };
    async function handContextMenu(action, bookingId) {
        handleClose();
        if (props.handContextMenu) {
            props.handContextMenu(action, bookingId, (contextMenu?.slotTime) ? contextMenu.slotTime : null);
        }
    };

    const categoryCounts = useMemo(() => {
        const allCategories = props.data["Yms_Categories"] || [];
        const counts = {};
        allCategories.forEach(category => {
            if (category.Descr1) {
                counts[category.Descr1] = 0;
            }
        });

        let totalCountOfItems = 0;
        let totalPallets = 0;
        const categoryItems = {};
        const categoryPallets = {};

        allCategories.forEach(category => {
            if (category.Descr1) {
                categoryItems[category.Descr1] = 0;
                categoryPallets[category.Descr1] = 0;
            }
        });

        const tasksToProcess = sumCategoriesData.length > 0 ? sumCategoriesData : [];

        if (tasksToProcess.length > 0) {
            tasksToProcess.forEach(task => {
                if (task.CATEGORYID) {
                    const category = allCategories.find(cat => cat.CategoryId === task.CATEGORYID);
                    if (category && category.Descr1) {
                        const categoryName = category.Descr1;
                        counts[categoryName] = (counts[categoryName] || 0) + 1;

                        if (task.COUNTOFITEMS) {
                            const itemCount = Number(task.COUNTOFITEMS) || 0;
                            categoryItems[categoryName] += itemCount;
                            totalCountOfItems += itemCount;
                        }
                        if (task.PALLETS) {
                            const palletCount = Number(task.PALLETS) || 0;
                            categoryPallets[categoryName] += palletCount;
                            totalPallets += palletCount;
                        }
                    }
                }
            });
        }

        return { counts, totalCountOfItems, totalPallets };
    }, [props.data, sumCategoriesData]);

    const isAdminOrPlanner = role === "Admin" || role === "Planner";

    const { onCategoriesUpdate } = props;

    useEffect(() => {
        if (onCategoriesUpdate) {
            onCategoriesUpdate(categoryCounts.counts);
        }
    }, [categoryCounts.counts, onCategoriesUpdate]);

    if (!props.warehouseid) return;

    const { counts: categoryCountsMap, totalCountOfItems, totalPallets } = categoryCounts;

    return (
        <div className="grid-container-day" style={{ gridTemplateRows: !isAdminOrPlanner ? '0fr repeat(4, 1fr)' : undefined }}>
            <ErrorAlert message={props.errorMessageFromSave} setMessage={props.setErrorMessageFromSave} language={language} />
            {isAdminOrPlanner && (
                <div className="title-inDay grid-container-day-title">


                    <div>
                        <div className="flex gap-6 flex-wrap" style={{ flexDirection: 'column' }}>
                            <div className="flex items-center gap-2">
                                <i className="bi bi-columns-gap" style={{ fontSize: '12px', color: 'var(--color-main-background)', marginRight: '1px' }}></i>
                                <span className="text-sm font-semibold text-slate-700">
                                    {t('ModalBooking.sumPallets', language)}
                                    <span className="ml-1 text-blue-600 font-bold"> {totalPallets}</span>
                                </span>
                            </div>
                            <div className="flex items-center gap-2">
                                <i className="bi bi-box-seam" style={{ fontSize: '12px', color: 'var(--color-main-background)', marginRight: '1px' }}></i>
                                <span className="text-sm font-semibold text-slate-700">
                                    {t('ModalBooking.sumItems', language)}
                                    <span className="ml-1 text-blue-600 font-bold"> {totalCountOfItems}</span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-col gap-2">
                        <div className="flex flex-wrap gap-2">
                            {Object.entries(categoryCountsMap).map(([categoryName, count]) =>
                                count > 0 && (
                                    <div key={categoryName} className="tag-item">
                                        <span className="tag-count">{count}</span>
                                        <span className="tag-name">{categoryName}</span>
                                    </div>
                                )
                            )}
                        </div>
                    </div>


                </div>
            )}
            <Box className="calendar-day-view grid-container-day-content" >
                <div className="calendar-day-time-slots" >
                    {timeSlots.map((slotTime, index) => {
                        const slotMatch = capacityPerTimeSlot.find(cap => {
                            const capTime = parse(cap.TIMESLOT, "dd/MM/yyyy HH:mm", new Date());
                            return capTime.getHours() === slotTime.getHours();
                        });



                        const percentage = (slotMatch && slotMatch.TOTAL_CAPACITY > 0)
                            ? Math.round((slotMatch.RESERVED_CAPACITY / slotMatch.TOTAL_CAPACITY) * 100)
                            : 0;

                        const isAdminOrPlanner = role === "Admin" || role === "Planner";
                        const isFull = percentage >= 100;
                        const isEmpty = percentage === 0;
                        
                        let capacityText;
                        if (isAdminOrPlanner) {
                            capacityText = `${percentage}%`;
                        } else if (isFull) {
                            capacityText = t("bookingCalendar.full", language);
                        } else {
                            capacityText = t("bookingCalendar.free", language);
                        }

                        const capacityClasses = [
                            'Capacity',
                            isFull && 'full-capacity-percentage',
                            (isEmpty || (percentage < 100 && !isAdminOrPlanner)) && 'without-capacity-percentage'
                        ].filter(Boolean).join(' ');

                        const ymsBookingsPerHours = ymsBookingsPerDay.filter((recYmsbook) => {
                            const fromDate = new Date(recYmsbook.FromDate);
                            if (!(fromDate instanceof Date) || isNaN(fromDate)) return false;

                            const capacity = Number(recYmsbook.CapacityMinutes) || 30;
                            const endBooking = new Date(fromDate);
                            endBooking.setMinutes(endBooking.getMinutes() + capacity);

                            const slotEndTime = new Date(slotTime);
                            slotEndTime.setHours(slotTime.getHours() + 1);

                            // Check if booking overlaps with this time slot
                            // Booking overlaps if: booking_start < slot_end AND booking_end > slot_start
                            return (fromDate < slotEndTime && endBooking > slotTime);
                        });
                        const columnMapGlobal = {};
                        const maxEventRight = ymsBookingsPerDay.reduce((max, recYmsbook) => {
                            const eventStart = new Date(recYmsbook.FromDate);
                            const capacity = Number(recYmsbook.CapacityMinutes || 30);
                            const eventEnd = new Date(eventStart);
                            eventEnd.setMinutes(eventEnd.getMinutes() + capacity);

                            const startSlotIndex = timeSlots.findIndex(slot => slot.getTime() >= eventStart.getTime());
                            const endSlotIndex = timeSlots.findIndex(slot => slot.getTime() >= eventEnd.getTime());

                            let usedColumns = new Set();
                            for (let i = startSlotIndex; i < endSlotIndex; i++) {
                                if (!columnMapGlobal[i]) columnMapGlobal[i] = new Set();
                                columnMapGlobal[i].forEach(col => usedColumns.add(col));
                            }

                            let colIndex = 0;
                            while (usedColumns.has(colIndex)) colIndex++;

                            for (let i = startSlotIndex; i < endSlotIndex; i++) {
                                columnMapGlobal[i].add(colIndex);
                            }

                            const right = 90 + (colIndex * 90) + 90;
                            return Math.max(max, right);
                        }, window.innerWidth);

                        const slotWidth = maxEventRight;
                        return (
                            <Box key={index}
                                className={`calendar-hour-slot ${percentage >= 100 ? 'full-capacity' : ''}`}
                                style={{ '--capacity': `${(role === "Admin" || role === "Planner") && percentage < 100 ? percentage : 0}%`, width: typeof slotWidth === 'number' ? `${slotWidth}px` : slotWidth }}
                                onContextMenu={(event) => {
                                    event.preventDefault();
                                    if (isEventContextMenuOpen) {
                                        setContextMenu(null);
                                        return;
                                    }
                                    if (props.isHoliday || !isTodayOrFutureDate(props.currentDate)) {
                                        setContextMenu(null);
                                        return;
                                    }

                                    setContextMenu({
                                        mouseX: event.clientX,
                                        mouseY: (event.clientY > event.screenY) ? event.screenY : event.clientY,
                                        slotTime: slotTime
                                    });
                                    contextMenuDataRef.current = {
                                        percentage: percentage,
                                        slotTime: slotTime
                                    };
                                }
                                }
                            >
                                <div className={capacityClasses}>{capacityText}</div>
                                <Typography variant="body1" className="calendar-hour">
                                    {format(slotTime, "HH:mm")}
                                </Typography>
                                {ymsBookingsPerHours.length > 0 && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {ymsBookingsPerHours.map((recYmsbook) => {
                                            const eventStart = new Date(recYmsbook.FromDate);
                                            const capacity = Number((recYmsbook.CapacityMinutes) ? recYmsbook.CapacityMinutes : 30);
                                            const eventEnd = new Date(eventStart)
                                            eventEnd.setMinutes(eventEnd.getMinutes() + capacity);
                                            if (isNaN(eventStart) || isNaN(eventEnd)) return null;
                                            if (renderedEventIds.has(recYmsbook.BookingId)) return null;
                                            renderedEventIds.add(recYmsbook.BookingId);
                                            const currentSlotIndex = index;
                                            if (!slotStackMap[currentSlotIndex]) slotStackMap[currentSlotIndex] = 0;
                                            slotStackMap[currentSlotIndex]++;
                                            const positionTop = `-3px`;
                                            let height = '95px';
                                            if (hoveredBookingId === recYmsbook.BookingId) {
                                                const capMinutes = Number(recYmsbook.CapacityMinutes || 30);
                                                const heightValue = capMinutes < 65 ? capMinutes * 1.60 : capMinutes * 1.80;
                                                height = `${Math.max(40, Math.round(heightValue))}px`;
                                            }
                                            let usedColumns = new Set();
                                            if (!columnMap[currentSlotIndex]) columnMap[currentSlotIndex] = new Set();
                                            columnMap[currentSlotIndex].forEach((col) => usedColumns.add(col));
                                            let colIndex = 0;
                                            while (usedColumns.has(colIndex)) colIndex++;
                                            columnMap[currentSlotIndex].add(colIndex);
                                            const positionLeft = `${90 + (colIndex * 85)}px`;
                                            const { dotColor, statusName, bgColor } = props.getEventColors(recYmsbook.Status);
                                            const isDisabled = gatDisabledView(recYmsbook);
                                            return (
                                                <CalendarEventDay
                                                    key={recYmsbook.BookingId}
                                                    userToken={props.userToken}
                                                    Ymsbook={recYmsbook}
                                                    YmsbookTask={props.data["Yms_BookingTasks"] ? props.data["Yms_BookingTasks"].filter(task => task.BookingId === recYmsbook.BookingId) : []}
                                                    eventStart={eventStart}
                                                    eventEnd={recYmsbook.ToDate}
                                                    dotColor={dotColor}
                                                    statusName={statusName}
                                                    bgColor={bgColor}
                                                    selected={props.selectedEvent === recYmsbook.BookingId}
                                                    positionTop={positionTop}
                                                    positionLeft={positionLeft}
                                                    height={height}
                                                    onHoverChange={(isHovering, bookingId) => {
                                                        setHoveredBookingId(isHovering ? bookingId : null);
                                                    }}
                                                    handContextMenu={handContextMenu}
                                                    userApp={props.userApp}
                                                    isDisabled={isDisabled}
                                                    setIsEventContextMenuOpen={setIsEventContextMenuOpen}
                                                    currentDate={props.currentDate}
                                                // isFirstTwoSlots={isFirstTwoSlots}
                                                />
                                            );
                                        })}
                                    </div>
                                )}
                            </Box>
                        );
                    })}
                </div>
                <Menu
                    open={contextMenu !== null}
                    onClose={handleClose}
                    className="calendar-event-menu"
                    anchorReference="anchorPosition"
                    anchorPosition={
                        contextMenu !== null
                            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                            : undefined
                    }
                >

                    {(() => {
                        const isValidDay = !props.isHoliday && isTodayOrFutureDate(props.currentDate);
                        const percentage = contextMenuDataRef.current?.percentage || 0;
                        const canCreateNewBooking =
                            ((isValidDay && percentage < 100) || role === "Admin" || role === "Planner");
                        const canCreateScheduledBooking = isValidDay && (role === "Admin" || role === "Planner");
                        const noActionsAllowed = !canCreateNewBooking && !canCreateScheduledBooking;

                        return (
                            <>
                                {canCreateNewBooking && (
                                    <MenuItem onClick={() => handContextMenu("New", 0)}>
                                        <AddBoxIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                        {t("contextMenu.newBooking", language)}
                                    </MenuItem>
                                )}
                                {canCreateScheduledBooking && (
                                    <MenuItem onClick={() => handContextMenu("Scheduled", 0)}>
                                        <EventRepeatIcon fontSize="medium" style={{ marginRight: 10, color: "var(--color-main-background)" }} />
                                        {t("contextMenu.scheduledBooking", language)}
                                    </MenuItem>
                                )}
                                {noActionsAllowed && (
                                    <MenuItem disabled>
                                        {t("calendarEvent.noActions", language)}
                                    </MenuItem>
                                )}

                            </>
                        );
                    })()}
                </Menu>
            </Box>

        </div>
    );
}

export default DayView;
